'use client';

import { c as _c } from "react/compiler-runtime";
import { ChevronLeftIcon } from '@heroicons/react/24/outline';
import closeIcon from '@public/images/close_white.svg';
import { useKeenSlider } from 'keen-slider/react';
import Image from 'next/image';
import { Button } from '@src/components/Button/Button';
import { LocalizedLink } from '@src/components/LocalizedLink/LocalizedLink';
import { useTopNavV6 } from '@src/components/TopNavV6/TopNavV6Context';
import type { TopNavV6SubNavItem } from '@src/components/TopNavV6/TopNavV6Props';
import { TopNavV6Tile } from '@src/components/TopNavV6/TopNavV6Tile';
import { useTrackSelectNavCta } from '@src/utils/analytics.util';
import { cn } from '@src/utils/tailwind';
interface TopNavV6MobileThirdLevelMenuProps {
  subNavItem: TopNavV6SubNavItem;
}
export const TopNavV6MobileThirdLevelMenu = t0 => {
  const $ = _c(37);
  const {
    subNavItem
  } = t0;
  const trackSelectNavCta = useTrackSelectNavCta();
  const {
    setSelectedThirdLevelMenu,
    setIsMobileMenuOpen
  } = useTopNavV6();
  let t1;
  if ($[0] !== setSelectedThirdLevelMenu) {
    t1 = () => {
      setSelectedThirdLevelMenu(null);
    };
    $[0] = setSelectedThirdLevelMenu;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const handleBack = t1;
  let t2;
  if ($[2] !== setIsMobileMenuOpen || $[3] !== setSelectedThirdLevelMenu) {
    t2 = () => {
      setSelectedThirdLevelMenu(null);
      setIsMobileMenuOpen(false);
    };
    $[2] = setIsMobileMenuOpen;
    $[3] = setSelectedThirdLevelMenu;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  const handleClose = t2;
  let t3;
  if ($[5] !== setIsMobileMenuOpen || $[6] !== setSelectedThirdLevelMenu || $[7] !== trackSelectNavCta) {
    t3 = href => {
      if (href) {
        trackSelectNavCta({
          "cta url": href
        });
        setIsMobileMenuOpen(false);
        setSelectedThirdLevelMenu(null);
      }
    };
    $[5] = setIsMobileMenuOpen;
    $[6] = setSelectedThirdLevelMenu;
    $[7] = trackSelectNavCta;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  const handleItemClick = t3;
  const ctaButton = subNavItem.mobileCtaButton;
  const thirdLevelMenu = subNavItem.navItems;
  const violators = (thirdLevelMenu?.violators ?? []).filter(_temp);
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      loop: false,
      mode: "snap",
      rubberband: false,
      slides: {
        perView: "auto",
        origin: "auto",
        spacing: 12
      }
    };
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  const [sliderRef] = useKeenSlider(t4);
  if (!thirdLevelMenu) {
    return null;
  }
  const isSingleViolator = violators.length === 1;
  const t5 = "flex h-full flex-col";
  let t6;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <ChevronLeftIcon className="size-6 text-bodi-accent-bright-500" />;
    $[10] = t6;
  } else {
    t6 = $[10];
  }
  let t7;
  if ($[11] !== handleBack) {
    t7 = <button className="flex size-6 appearance-none items-center justify-center" onClick={handleBack} data-testid="backThirdLevelMenu">{t6}</button>;
    $[11] = handleBack;
    $[12] = t7;
  } else {
    t7 = $[12];
  }
  let t8;
  if ($[13] !== subNavItem.title) {
    t8 = <div className="flex flex-1 items-center justify-center"><p className="text-body-md leading-[18px] font-semibold text-bodi-gray-butters uppercase">{subNavItem.title}</p></div>;
    $[13] = subNavItem.title;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <Image src={closeIcon} width={20} height={20} alt="Close menu" />;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== handleClose) {
    t10 = <button className="flex size-6 appearance-none items-center justify-center" onClick={handleClose} data-testid="closeThirdLevelMenu">{t9}</button>;
    $[16] = handleClose;
    $[17] = t10;
  } else {
    t10 = $[17];
  }
  let t11;
  if ($[18] !== t10 || $[19] !== t7 || $[20] !== t8) {
    t11 = <div className="flex h-12 items-center justify-between bg-linear-to-r from-white/8 to-white/8 px-4">{t7}{t8}{t10}</div>;
    $[18] = t10;
    $[19] = t7;
    $[20] = t8;
    $[21] = t11;
  } else {
    t11 = $[21];
  }
  const t12 = "flex flex-1 flex-col gap-8 overflow-y-auto px-4 pt-8 pb-8";
  let t13;
  if ($[22] !== handleItemClick || $[23] !== thirdLevelMenu.columns) {
    let t14;
    if ($[25] !== handleItemClick) {
      t14 = (column, columnIndex) => <div key={`column-${columnIndex}`} className="flex w-full flex-col">{column.title && <div className="mb-2 pb-2">{column.href ? <LocalizedLink href={column.href} onClick={() => handleItemClick(column.href)}><p className="text-body-base leading-6 font-medium text-white">{column.title}</p></LocalizedLink> : <p className="text-body-base leading-6 font-medium text-white">{column.title}</p>}</div>}{column.items && column.items.length > 0 && <div className="flex flex-col gap-3">{column.items.map((item, itemIndex) => {
            const isViewAllItem = (item.isShopAll ?? false) || item.title.toLowerCase().includes("view all") || item.title.toLowerCase().startsWith("all ");
            return <LocalizedLink href={item.href ?? "#"} key={`item-${itemIndex}`} className="flex w-full items-center text-left" onClick={() => {
              handleItemClick(item.href);
              item.onClick?.();
            }}><div className="flex items-center gap-1"><p className={cn("text-body-sm leading-5", isViewAllItem ? "text-bodi-accent-bright-500" : "text-bodi-gray-butters")}>{item.title}</p>{item.badge && <div className="flex items-center gap-1 text-body-sm leading-5"><span className="font-sans font-normal text-bodi-gray-butters">-</span><span className="text-center font-sans font-medium text-bodi-accent-bright-500">{item.badge}</span></div>}</div></LocalizedLink>;
          })}</div>}</div>;
      $[25] = handleItemClick;
      $[26] = t14;
    } else {
      t14 = $[26];
    }
    t13 = thirdLevelMenu.columns.map(t14);
    $[22] = handleItemClick;
    $[23] = thirdLevelMenu.columns;
    $[24] = t13;
  } else {
    t13 = $[24];
  }
  const t14 = violators.length > 0 && <div><div ref={sliderRef} className="keen-slider">{violators.map((violator_0, i) => {
        const width = isSingleViolator ? "100%" : "90%";
        return <div key={i} className="keen-slider__slide" style={{
          minWidth: width,
          maxWidth: width
        }}><TopNavV6Tile tile={violator_0} /></div>;
      })}</div></div>;
  let t15;
  if ($[27] !== t13 || $[28] !== t14) {
    t15 = <div className={t12}>{t13}{t14}</div>;
    $[27] = t13;
    $[28] = t14;
    $[29] = t15;
  } else {
    t15 = $[29];
  }
  let t16;
  if ($[30] !== ctaButton || $[31] !== handleItemClick) {
    t16 = ctaButton && ctaButton.title && ctaButton.title !== "" && <div className="bg-bodi-black-text px-4 py-5">{ctaButton.href ? <LocalizedLink href={ctaButton.href} onClick={() => {
        handleItemClick(ctaButton.href);
        ctaButton.onClick?.();
      }}><Button className="w-full rounded-full" contentClassName="tracking-normal" size="medium" variant="primary">{ctaButton.title}</Button></LocalizedLink> : <Button className="w-full rounded-full" contentClassName="tracking-normal" size="medium" variant="primary" onClick={() => {
        ctaButton.onClick?.();
      }}>{ctaButton.title}</Button>}</div>;
    $[30] = ctaButton;
    $[31] = handleItemClick;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  let t17;
  if ($[33] !== t11 || $[34] !== t15 || $[35] !== t16) {
    t17 = <div className={t5}>{t11}{t15}{t16}</div>;
    $[33] = t11;
    $[34] = t15;
    $[35] = t16;
    $[36] = t17;
  } else {
    t17 = $[36];
  }
  return t17;
};
function _temp(violator) {
  return violator.isVisible !== false;
}